import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "form-content-in-dialog" }
const _hoisted_2 = { class: "box-content" }
const _hoisted_3 = { class: "option-desc" }
const _hoisted_4 = {
  key: 0,
  class: "box-btns"
}
const _hoisted_5 = { class: "row" }
const _hoisted_6 = {
  key: 1,
  class: "dialog-btn-group len-2"
}

import { ISurveyQuestion, ISurveryOption } from '@/types/survey';
  import { ColorVariants } from '@/constants';
  import { ref } from 'vue';
  import { useI18n } from 'vue-i18n';
  // 有可能是modal.ts 的实例弹出来的，需要这个组件
  import AppLoadingButton from '@/components/loading-button.vue';

  interface IProps {
    question: ISurveyQuestion,
    onConfirm: (answer: { question: ISurveyQuestion, option?: ISurveryOption, input?: string }) => void;
    onCancel: () => void;
  }

  
export default /*#__PURE__*/_defineComponent({
  props: {
    question: null,
    onConfirm: null,
    onCancel: null
  },
  setup(__props: any) {

const props = __props as {
    question: ISurveyQuestion,
    onConfirm: (answer: { question: ISurveyQuestion, option?: ISurveryOption, input?: string }) => void;
    onCancel: () => void;
  }

  const { t } = useI18n();
  
  const OPTION_NAMES = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J'];
  const input = ref('');
  const handleAnswer = (option?: ISurveryOption) => {
    return props.onConfirm({
      question: props.question,
      option,
      input: input.value
    });
  };

  const handleCancel = () => {
    return props.onCancel();
  };

return (_ctx: any,_cache: any) => {
  const _component_b_form_input = _resolveComponent("b-form-input")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (__props.question.kind === 'choice')
        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(__props.question.survey_options, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: index,
              class: "option-desc"
            }, _toDisplayString(OPTION_NAMES[index]) + "." + _toDisplayString(item.text), 1))
          }), 128))
        : _createCommentVNode("", true),
      (__props.question.kind === 'input')
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createElementVNode("div", _hoisted_3, _toDisplayString(__props.question.tips), 1),
            _createVNode(_component_b_form_input, {
              modelValue: input.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((input).value = $event)),
              class: "input",
              required: "",
              type: "text"
            }, null, 8, ["modelValue"])
          ], 64))
        : _createCommentVNode("", true)
    ]),
    (__props.question.kind === 'choice')
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.question.survey_options, (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: index,
                class: "col-6"
              }, [
                _createVNode(AppLoadingButton, {
                  class: "btn",
                  pill: "",
                  variant: _unref(ColorVariants).primary,
                  onClick: ($event: any) => (handleAnswer(item))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(OPTION_NAMES[index]), 1)
                  ]),
                  _: 2
                }, 1032, ["variant", "onClick"])
              ]))
            }), 128))
          ])
        ]))
      : _createCommentVNode("", true),
    (__props.question.kind === 'input')
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createVNode(AppLoadingButton, {
            class: "btn",
            pill: "",
            variant: _unref(ColorVariants).outlinePrimary,
            onClick: handleCancel
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)('Close')), 1)
            ]),
            _: 1
          }, 8, ["variant"]),
          _createVNode(AppLoadingButton, {
            class: "btn",
            pill: "",
            variant: _unref(ColorVariants).primary,
            disabled: !input.value,
            onClick: _cache[1] || (_cache[1] = ($event: any) => (handleAnswer()))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)('Apply')), 1)
            ]),
            _: 1
          }, 8, ["variant", "disabled"])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})